import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { PublicLayout } from "@/components/site/PublicLayout";
import { AdminLayout } from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Booking from "@/pages/Booking";
import Teachers from "@/pages/Teachers";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Kvkk from "@/pages/Kvkk";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import Appointments from "@/pages/admin/Appointments";
import CrudPage from "@/pages/admin/CrudPage";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/kurslar" element={<Courses />} />
              <Route path="/kurslar/:slug" element={<CourseDetail />} />
              <Route path="/randevu" element={<Booking />} />
              <Route path="/ogretmenler" element={<Teachers />} />
              <Route path="/galeri" element={<Gallery />} />
              <Route path="/etkinlikler" element={<Events />} />
              <Route path="/hakkimizda" element={<About />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/kvkk" element={<Kvkk />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/yonetim/giris" element={<AdminLogin />} />
            <Route path="/yonetim" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Appointments />} />
              <Route path="ayarlar" element={<Settings />} />
              <Route path=":section" element={<CrudPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </SiteProvider>
  );
}

export default App;
